import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Binding",
      component: () => import("../pages/binding.vue"),
      meta: {
        title: "车务助手",
      },
    },
    {
      path: "/vhaBinding",
      name: "Binding",
      component: () => import("../pages/binding.vue"),
      meta: {
        title: "车务助手",
      },
    },
    {
      path: "/vhaHome",
      name: "Home",
      component: () => import("../pages/homePage.vue"),
      meta: {
        title: "车务助手",
      },
    },
    {
      path: "/personDetail",
      name: "personDetail",
      component: () => import("../pages/personDetail.vue"),
      meta: {
        title: "个人资料",
      },
    },
    {
      path: "/clientHome",
      name: "clientHome",
      component: () => import("../pages/clientHome.vue"),
      meta: {
        title: "车务通",
      },
    },
    {
      path: "/agentOrder",
      name: "agentOrder",
      component: () => import("../pages/agentOrder.vue"),
      meta: {
        title: "易鑫结清数据查询",
      },
    },
    {
      path: "/newOrder",
      name: "newOrder",
      component: () => import("../pages/newOrder.vue"),
      meta: {
        title: "新建订单",
      },
    },
    {
      path: "/releaseOrder",
      name: "releaseOrder",
      component: () => import("../pages/releaseOrder.vue"),
      meta: {
        title: "新建订单",
      },
    },
    {
      path: "/orderTrack",
      name: "orderTrack",
      component: () => import("../pages/orderTrack.vue"),
      meta: {
        title: "资料跟踪",
      },
    },
    {
      path: "/newResult",
      name: "newResult",
      component: () => import("../pages/newResult.vue"),
      meta: {
        title: "处理结果",
      },
    },
    {
      path: "/clientOrder",
      name: "clientOrder",
      component: () => import("../pages/clientOrder.vue"),
      meta: {
        title: "我的订单",
      },
    },
    ,
    {
      path: "/cusOrderDetail",
      name: "cusOrderDetail",
      component: () => import("../pages/cusOrderDetail.vue"),
      meta: {
        title: "主单明细",
      },
    },
    {
      path: "/mainOrderDetail",
      name: "mainOrderDetail",
      component: () => import("../pages/mainOrderDetail.vue"),
      meta: {
        title: "订单详情",
      },
    },
    {
      path: "/uploadCert",
      name: "uploadCert",
      component: () => import("../pages/uploadCert.vue"),
      meta: {
        title: "上传归还凭证",
      },
    },
    {
      path: "/offReason",
      name: "offReason",
      component: () => import("../pages/uploadCert.vue"),
      meta: {
        title: "退单原因",
      },
    },
    {
      path: "/list/:type",
      name: "list",
      component: () => import("../pages/list.vue"),
      meta: {
        title: "待派单",
      },
    },
    {
      path: "/myOrderList",
      name: "myOrderList",
      component: () => import("../pages/myOrderList.vue"),
      meta: {
        title: "我的订单",
      },
    },
    {
      path: "/RegionalOrderList",
      name: "RegionalOrderList",
      component: () => import("../pages/RegionalOrderList.vue"),
      meta: {
        title: "区域订单",
      },
    },
    {
      path: "/materials",
      name: "Materials",
      component: () => import("../pages/materials.vue"),
      meta: {
        title: "资料申请",
      },
    },
    {
      path: "/materialsDeatil",
      name: "MaterialsDeatil",
      component: () => import("../pages/materialsDeatil.vue"),
      meta: {
        title: "资料申请详请",
      },
    },
    {
      path: "/signedInfo",
      name: "signedInfo",
      component: () => import("../pages/signedInfo.vue"),
      meta: {
        title: "已签收资料",
      },
    },
    {
      path: "/seachCategory",
      name: "SeachCategory",
      component: () => import("../pages/seachCategory.vue"),
      meta: {
        title: "资料申请详请",
      },
    },

    {
      path: "/signFor",
      name: "signFor",
      component: () => import("../pages/signFor.vue"),
      meta: {
        title: "签收确认",
      },
    },
    {
      path: "/selectCompetent",
      name: "selectCompetent",
      component: () => import("../pages/selectCompetent.vue"),
      meta: {
        title: "选择主管",
      },
    },
    {
      path: "/processResult",
      name: "processResult",
      component: () => import("../pages/processResult.vue"),
      meta: {
        title: "处理结果",
      },
    },
    {
      path: "/failReasonResult",
      name: "failReasonResult",
      component: () => import("../pages/failReasonResult.vue"),
      meta: {
        title: "填写退单原因",
      },
    },
    {
      path: "/failResult",
      name: "failResult",
      component: () => import("../pages/failResult.vue"),
      meta: {
        title: "填写退单原因",
      },
    },
    {
      path: "/reserveWorkTime",
      name: "reserveWorkTime",
      component: () => import("../pages/reserveWorkTime.vue"),
      meta: {
        title: "更改办理时间",
      },
    },
    {
      path: "/dbrRemark",
      name: "dbrRemark",
      component: () => import("../pages/dbrRemark.vue"),
      meta: {
        title: "填写备注",
      },
    },
    {
      path: "/stateTrack",
      name: "stateTrack",
      component: () => import("../pages/stateTrack.vue"),
      meta: {
        title: "订单跟踪",
      },
    },
    {
      path: "/applyRework",
      name: "applyRework",
      component: () => import("../pages/applyRework.vue"),
      meta: {
        title: "申请退单",
      },
    },
    {
      path: "/rePend",
      name: "rePend",
      component: () => import("../pages/rePend.vue"),
      meta: {
        title: "改派代办人",
      },
    },
    {
      path: "/materialDemo",
      name: "materialDemo",
      component: () => import("../pages/materialDemo.vue"),
      meta: {
        title: "资料示例",
      },
    },
    {
      path: "/reciveUpload",
      name: "reciveUpload",
      component: () => import("../pages/reciveUpload.vue"),
      meta: {
        title: "上传收件凭证",
      },
    },
    {
      path: "/yyCheckActions",
      name: "yyCheckActions",
      component: () => import("../pages/yyCheckActions.vue"),
      meta: {
        title: "审核订单",
      },
    },
    {
      path: "/orderReceive",
      name: "orderReceive",
      component: () => import("../pages/orderReceive.vue"),
      meta: {
        title: "接单反馈",
      },
    },
    {
      path: "/signContract/:id",
      name: "signContract",
      component: () => import("../pages/signContract.vue"),
      meta: {
        title: "签约",
      },
    },
    {
      path: "/invoice",
      name: "invoice",
      component: () => import("../pages/invoice.vue"),
      meta: {
        title: "发票",
      },
    },
    {
      path: "/signPay",
      name: "signPay",
      component: () => import("../pages/signPay.vue"),
      meta: {
        title: "签约",
      },
    },
    {
      path: "/snatchList",
      name: "snatchList",
      component: () => import("../pages/snatchList.vue"),
      meta: {
        title: "待抢单",
      },
    },
    {
      path: "/completeInfo",
      name: "completeInfo",
      component: () => import("../pages/completeInfo.vue"),
      meta: {
        title: "补全订单信息",
      },
    },
    {
      path: "/messageParent",
      name: "messageParent",
      component: () => import("../pages/messageParent.vue"),
      meta: {
        title: "新消息通知",
      },
    },
    {
      path: "/pay",
      name: "pay",
      component: () => import("../pages/pay.vue"),
      meta: {
        title: "支付",
      },
    },
    {
      path: "/fileDeatils",
      name: "fileDeatils",
      component: () => import("../pages/fileDeatils.vue"),
      meta: {
        title: "添加文件",
      },
    },
    {
      path: "/unfinished",
      name: "unfinished",
      component: () => import("../pages/unfinished.vue"),
      meta: {
        title: "我的全部未完成",
      },
    },
    {
      path: "/choosPlace",
      name: "choosPlace",
      component: () => import("../pages/choosPlace.vue"),
      meta: {
        title: "修改办理地点",
      },
    },
    {
      path: "/choosePeopple",
      name: "choosePeopple",
      component: () => import("../pages/choosePeopple.vue"),
      meta: {
        title: "实际办理人员",
      },
    },
    {
      path: "/chargebackList/:type",
      name: "chargebackList",
      component: () => import("../pages/chargebackList.vue"),
      meta: {
        title: "待退单",
      },
    },
    {
      path: "/messageChild",
      name: "messageChild",
      component: () => import("../pages/messageChild.vue"),
      meta: {
        title: "新订单通知",
      },
    },
    {
      path: "/replaceCreate",
      name: "replaceCreate",
      component: () => import("../pages/replaceCreate.vue"),
      meta: {
        title: "代下服务创收订单",
      },
    },
    {
      path: "/contractPay",
      name: "contractPay",
      component: () => import("../pages/contractPay.vue"),
      meta: {
        title: "签约付款",
      },
    },
    {
      path: "/onlineOrder",
      name: "onlineOrder",
      component: () => import("../pages/onlineOrder.vue"),
      meta: {
        title: "查询线上抵解押订单",
      },
    },
    {
      path: "/addInfo",
      name: "addInfo",
      component: () => import("../pages/addInfo.vue"),
      meta: {
        title: "补充车辆信息",
      },
    },
    {
      path: "/waitAddCarInfo",
      name: "waitAddCarInfo",
      component: () => import("../pages/waitAddCarInfo.vue"),
      meta: {
        title: "待补充车辆信息",
      },
    },


    // /////////////////////////////////////////////将老站点（vhs）的绑定和解绑迁移到此项目（vha）中/////////////////////////////////

    {
      path: "/Custwechatinfo",
      name: "Custwechatinfo",
      component: () => import("../pages/custWechatInfo.vue"),
      meta: {
        title: "微信通知设置",
      },
    },
    {
      path: "/UnbindingWechat",
      name: "UnbindingWechat",
      component: () => import("../pages/unbindingWechat.vue"),
      meta: {
        title: "解除绑定设置",
      },
    },
    // 国银普惠
    {
      path: "/mortgageCityQuery",
      name: "mortgageCityQuery",
      component: () => import("../pages/guoyinpuhui/mortgageCityQuery.vue"),
      meta: {
        title: "抵押城市查询",
      },
    },
    {
      path: "/mortgageProgress",
      name: "mortgageProgress",
      component: () => import("../pages/guoyinpuhui/mortgageProgress.vue"),
      meta: {
        title: "抵押进度总览",
      },
    },
    {
      path: "/handleSettleBus",
      name: "handleSettleBus",
      component: () => import("../pages/guoyinpuhui/handleSettleBus.vue"),
      meta: {
        title: "办结业务查询",
      },
    },
    // //////////////////////////////////////////////////////////////迁移结束//////////////////////////////////////////////////
    // 车务通签署平台
    {
      path: "/contractSign",
      name: "contractSign",
      component: () => import("../pages/contract-sign/contract-sign.vue"),
      meta: {
        title: "请等待",
      },
    },
    {
      path: "/signPlatform",
      name: "signPlatform",
      component: () => import("../pages/contract-sign/sign-platform.vue"),
      meta: {
        title: "车务通签署平台",
      },
    },
    {
      path: "/signOrder",
      name: "signOrder",
      component: () => import("../pages/contract-sign/sign-order.vue"),
      meta: {
        title: "我的签署订单",
      },
    },
    {
      path: "/batchSelectSignOrder",
      name: "batchSelectSignOrder",
      component: () => import("../pages/contract-sign/batch-select-sign-order.vue"),
      meta: {
        title: "批量选择签署订单",
      },
    },
    {
      path: '/funderSignPlatform',
      redirect: to => {
        // 你可以根据 to.query、to.params 等做更复杂的处理
        return { path: '/signPlatform', query: { actor: 1 } }
      }
    },
    {
      path: "/signDetail",
      name: "signDetail",
      component: () => import("../pages/contract-sign/sign-detail.vue"),
      meta: {
        title: "签署订单详情",
      },
    },
    {
      path: "/agentVerifyFree",
      name: "agentVerifyFree",
      component: () => import("../pages/contract-sign/agent-verify-free.vue"),
      meta: {
        title: "免验签授权",
      },
    },
    {
      path: "/supplyInfo",
      name: "supplyInfo",
      component: () => import("../pages/contract-sign/supply-info.vue"),
      meta: {
        title: "补充身份信息",
      },
    },
    {
      path: "/signContract",
      name: "signContract",
      component: () => import("../pages/contract-sign/sign-contract.vue"),
      meta: {
        title: "签署合同",
      },
    },
    {
      path: "/signTransfer",
      name: "signTransfer",
      component: () => import("../pages/contract-sign/sign-transfer.vue"),
      meta: {
        title: "请等待",
      },
    },

    // {
    //   path: "/userAgreement",
    //   name: "userAgreement",
    //   component: () => import("../pages/contract-sign/user-agreement.vue"),
    //   meta: {
    //     title: "车务通签署平台服务协议",
    //   },
    // },

    // 顺丰
    {
      path: "/sendOrder",
      name: "sendOrder",
      component: () => import("../pages/shunfeng/send-order.vue"),
      meta: {
        title: "预约寄件",
      },
    },
    {
      path: "/reserveMail",
      name: "reserveMail",
      component: () => import("../pages/shunfeng/reserveMail.vue"),
      meta: {
        title: "预约寄件",
      },

    },
    {
      path: "/expressOrder",
      name: "expressOrder",
      component: () => import("../pages/shunfeng/expressOrder.vue"),
      meta: {
        title: "快递订单",
      },

    },
    {
      path: "/expressResult",
      name: "expressResult",
      component: () => import("../pages/shunfeng/expressResult.vue"),
      meta: {
        title: "预约寄件",
      },

    },
  ],
});

router.beforeEach((to, from, next) => {
  let homeData = JSON.parse(sessionStorage.getItem("homeData"));
  if (to.path.indexOf("dbtd") > -1) {
    to.meta.title = "代办退单";
  } else if (to.path.indexOf("yxz") > -1) {
    to.meta.title = "已选择";
  } else if (to.path.indexOf("myOrderList") > -1) {
    to.meta.title = "我的订单";
  } else if (to.path.indexOf("RegionalOrderList") > -1) {
    to.meta.title = "区域订单";
  } else if (to.path.indexOf("unfinished") > -1) {
    to.meta.title = "我的未完成";
  } else if (to.path.indexOf("dtd") > -1) {
    to.meta.title = "待退单";
  } else if (to.path.indexOf("dgh") > -1) {
    homeData.dgh == 0
      ? (to.meta.title = "待归还")
      : (to.meta.title = "待归还" + " (" + homeData.dgh + ")");
  } else if (to.path.indexOf("dsj") > -1) {
    homeData.dsj == 0
      ? (to.meta.title = "待收件")
      : (to.meta.title = "待收件" + " (" + homeData.dsj + ")");
  } else if (to.path.indexOf("bjq") > -1) {
    homeData.bjq == 0
      ? (to.meta.title = "被拒签")
      : (to.meta.title = "被拒签" + " (" + homeData.bjq + ")");
  } else if (to.path.indexOf("mx") > -1) {
    to.meta.title = "主单明细";
  } else if (to.path.indexOf("type=yb") > -1) {
    to.meta.title = "主单明细";
  } else if (to.query.type == "fail") {
    to.meta.title = "退单";
  } else if (to.query.type == "complete" || to.query.type == "express") {
    to.meta.title = "上传凭证";
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js